import { Button, Checkbox, List } from "antd";
import { useEffect, useState } from "react";
import CustomModal from "../../../../../../components/ui/CustomModal";
import Loader from "../../../../../../components/ui/Loader";
import { useGetAllDepartmentQuery } from "../../../../../../features/superAdmin/employeeService/employeeManagementService";
import { useForwardTicketToDepartmentMutation } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.api";
import useError from "../../../../../../hooks/useError";
import { toast } from "../../../../../../lib/toast";
import { ModalComponentProps } from "../../../../../../types";

type Props = ModalComponentProps & {
  id?: number | string;
};

const ForwardWorkflowTicketModal = ({
  handleClose,
  open,
  id,
  ...rest
}: Props) => {
  const [departments, setDepartments] = useState<number | null>(null);

  const {
    isError: isDeptError,
    error: deptError,
    data: departmentsResponse,
    isLoading: isDeptLoading,
  } = useGetAllDepartmentQuery({
    params: {
      page: 1,
      limit: 100000000,
      status: "active",
    },
  });

  const [
    forwardTicket,
    {
      isError: isForwardError,
      error: forwardError,
      isSuccess: isForwarded,
      isLoading: forwarding,
    },
  ] = useForwardTicketToDepartmentMutation();

  const handleForwardTicket = () => {
    if (!departments) {
      toast("warning", "Please select a department.");
      return;
    }

    forwardTicket({
      id: id,
      data: { department_id: departments },
    });
  };

  useEffect(() => {
    if (isForwarded) {
      handleClose();
      toast("success", "Ticket forwarded successfully.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isForwarded]);

  // Errors
  useError(isDeptError, deptError, "Get all department list fail");
  useError(isForwardError, forwardError, "Forward ticket fail");

  return (
    <>
      <CustomModal
        title="Forward Ticket"
        open={open}
        handleClose={handleClose}
        width={360}
        footer={null}
        {...rest}
      >
        <div>
          <div>
            {isDeptLoading ? (
              <div className="h-[300px]">
                <Loader />
              </div>
            ) : (
              <div className="h-[300px] overflow-auto pr-2 pt-3 border-t border-t-[#cccccc]">
                <List
                  dataSource={departmentsResponse?.data || []}
                  renderItem={(dep: any) => (
                    <List.Item
                      key={dep?.id}
                      className="!flex !justify-between !items-center"
                    >
                      <div className="text-[17px]">{dep?.name}</div>
                      <Checkbox
                        checked={departments === dep?.id}
                        onChange={() =>
                          setDepartments(
                            departments === dep?.id ? null : dep?.id,
                          )
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            )}
          </div>
          <div className="py-2 flex justify-between">
            <Button
              className="button-bordered-light h-10"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              loading={forwarding}
              onClick={handleForwardTicket}
              disabled={!departments}
              color="primary"
              className="button-primary-light h-10"
            >
              Forward
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ForwardWorkflowTicketModal;
